import axiosService from "../../services/axios-util/axios-services";

export type LoginRequestBody = { email: string; password: string };
const login = async (body: LoginRequestBody): Promise<any> => {
  const response = await axiosService.post(`mng/admin_users/sign_in`, { "mng_admin_user": body });
  return response
}

const logout = async (): Promise<any> => {
  const response = await axiosService.delete(`mng/admin_users/sign_out`);
  return response
}

const loginServices = {
  login,
  logout
}

export default loginServices;
